import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './FormularioContacto.css';

const FormularioContacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    mensaje: '',
  });

  const [captchaToken, setCaptchaToken] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [estadoMensaje, setEstadoMensaje] = useState({ tipo: '', texto: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setEstadoMensaje({ tipo: 'error', texto: '⚠️ Por favor, verificá el reCAPTCHA.' });
      return;
    }

    setEnviando(true);
    setEstadoMensaje({ tipo: '', texto: '' });

    try {
      const response = await fetch('https://whiskyandco.com.ar/api/email/enviar-contacto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, captchaToken }),
      });

      if (response.ok) {
        setEstadoMensaje({ tipo: 'success', texto: '✅ ¡Mensaje enviado correctamente!' });
        setFormData({ nombre: '', telefono: '', email: '', mensaje: '' });
        setCaptchaToken(null);
      } else {
        setEstadoMensaje({ tipo: 'error', texto: '❌ Hubo un error al enviar el mensaje.' });
      }
    } catch (error) {
      setEstadoMensaje({ tipo: 'error', texto: '❌ Error al conectar con el servidor.' });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="formulario-contacto-container">
      <h2>Ponete en contacto con nosotros</h2>

      {/* ✅ Mensaje visual */}
      {estadoMensaje.texto && (
        <div className={`alert ${estadoMensaje.tipo === 'success' ? 'alert-success' : 'alert-danger'}`}>
          {estadoMensaje.texto}
        </div>
      )}

      <form className="formulario-contacto" onSubmit={handleSubmit}>
        <div className="input-container">
          <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required placeholder=" " />
          <label>Nombre y apellido</label>
        </div>

        <div className="input-container">
          <input type="text" name="telefono" value={formData.telefono} onChange={handleChange} required placeholder=" " />
          <label>N° de teléfono</label>
        </div>

        <div className="input-container">
          <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder=" " />
          <label>Mail</label>
        </div>

        <div className="input-container">
          <textarea name="mensaje" value={formData.mensaje} onChange={handleChange} required placeholder=" " />
          <label>Mensaje</label>
        </div>

        <div className="d-flex justify-content-center">
          <ReCAPTCHA
            sitekey="6LcN0P4qAAAAAD6IfXS6DpnB1fz5lz7kNkv6dWtM"
            onChange={handleCaptchaChange}
          />
        </div>

        <div className="d-flex justify-content-center mt-3">
          <button type="submit" disabled={enviando}>
            {enviando ? 'Enviando...' : 'Enviar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FormularioContacto;
